/**
 * `path_PathGroupConditionsResource` container + key registry.
 * For Media Devoted | Created By Ciro Autiero
 */

import type {
  VoluumBrandCondition,
  VoluumBrowserCondition,
  VoluumCustomVariableCondition,
  VoluumIpCondition,
  VoluumOperatingSystemCondition,
  VoluumTimeOfDayCondition,
  VoluumWeekdayCondition,
} from './compound-resources.types';
import type {
  VoluumCityCondition,
  VoluumConnectionTypeCondition,
  VoluumCountryCondition,
  VoluumDeviceTypeCondition,
  VoluumIspCondition,
  VoluumLanguageCondition,
  VoluumMobileCarrierCondition,
  VoluumProxyCondition,
  VoluumReferrerCondition,
  VoluumReferrerDomainCondition,
  VoluumRegionCondition,
  VoluumUniqueVisitCondition,
} from './simple-resources.types';

/**
 * `path_PathGroupConditionsResource`. Every named branch is optional; unknown
 * branches round-trip via the `[key: string]: unknown` index signature.
 */
export interface VoluumPathGroupConditions {
  brand?: VoluumBrandCondition;
  browser?: VoluumBrowserCondition;
  city?: VoluumCityCondition;
  connectionType?: VoluumConnectionTypeCondition;
  country?: VoluumCountryCondition;
  customVariable?: VoluumCustomVariableCondition;
  deviceType?: VoluumDeviceTypeCondition;
  ip?: VoluumIpCondition;
  isp?: VoluumIspCondition;
  language?: VoluumLanguageCondition;
  mobileCarrier?: VoluumMobileCarrierCondition;
  operatingSystem?: VoluumOperatingSystemCondition;
  proxy?: VoluumProxyCondition;
  referrer?: VoluumReferrerCondition;
  referrerDomain?: VoluumReferrerDomainCondition;
  region?: VoluumRegionCondition;
  timeOfDay?: VoluumTimeOfDayCondition;
  uniqueVisit?: VoluumUniqueVisitCondition;
  weekdays?: VoluumWeekdayCondition;
  [key: string]: unknown;
}

/** Keys of the typed condition branches (for codec/registry iteration). */
export const VOLUUM_CONDITION_KEYS = [
  'brand',
  'browser',
  'city',
  'connectionType',
  'country',
  'customVariable',
  'deviceType',
  'ip',
  'isp',
  'language',
  'mobileCarrier',
  'operatingSystem',
  'proxy',
  'referrer',
  'referrerDomain',
  'region',
  'timeOfDay',
  'uniqueVisit',
  'weekdays',
] as const;

export type VoluumConditionKey = (typeof VOLUUM_CONDITION_KEYS)[number];
